export const NO_COMPONENT_DIR_ERROR =
  'No componentDir provided. Please check you have supplied a componentName in your Sitecore form datasource.';

export const NO_STEPS_DATA_ERROR = 'No steps data. Please add some steps in Sitecore.';
